import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Categories.svg",
  "use": "Categories.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Categories.svg\"><path d=\"M52.0208,25.0208v26a3,3,0,0,1-3,3h-34a3,3,0,0,1-3-3v-26a3,3,0,0,1,3-3h34A3,3,0,0,1,52.0208,25.0208Zm-33-11a1,1,0,0,1-1-1,3,3,0,0,1,3-3h22a3,3,0,0,1,3,3,1,1,0,0,1-1,1Zm30,5a1,1,0,0,1-1,1h-32a1,1,0,0,1-1-1,3,3,0,0,1,3-3h28A3,3,0,0,1,49.0208,19.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol